module.exports = "/assets/data/6a70876730ea9e6eb5fca941158fbed5-M18.data.json";